import React from 'react';
import { Outlet } from 'react-router-dom';

import logoWhiteImage from '../../../assets/img/logo_white.png';

import { Box } from '../../components/Box/Box';
import { Form } from '../../components/Form/Form';
import { Typography } from '../../components/Typography/Typography';
import { VERSION_DISPLAY } from '../../global/config';

export const AuthRoot = (): React.ReactElement => {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.primary.main
      })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '480px', alignItems: 'center' }}>
        <img
          src={logoWhiteImage}
          alt='Logo'
          style={{ maxHeight: '96px', width: '164px', display: 'block', marginBottom: 2 }}
        />
        <Form style={{ width: '100%', paddingLeft: 1, paddingRight: 1 }}>
          <Outlet />
        </Form>
        <Typography color='primaryInverted' text={VERSION_DISPLAY} sx={{ marginTop: 2 }} />
      </Box>
    </Box>
  );
};
